import React from 'react'

import ViolationsSelectedActionBar from '../components/ViolationsSelectedActionBar'
import { TableProvider, useTable } from '@/modules/drivers/context/TableContext'
import ViolationsGrupedTable from '../components/ViolationGrupedTable'

const ViolationsGroupedInner = () => {
  const { isSelectedAny } = useTable()

  return (
    <div className="tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden">
      {/* <ViolationsActionBar /> */}
      <ViolationsSelectedActionBar/>
      {/* <TableProvider> */}
        <ViolationsGrupedTable />
      {/* </TableProvider> */}
    </div>
  )
}

const ViolationsGrouped = () => {
  return (
    <TableProvider>
      <ViolationsGroupedInner />
    </TableProvider>
  )
}

export default ViolationsGrouped
